import { actions } from 'react-redux-form';
import { httpGet, httpPost } from '../../../../../../utils/api.utils';
import { CIRCUIT_TYPES as CIRCUITTYPES, SUB_CIRCUIT_TYPES as SUBCIRCUITTYPES } from '../../../../../../utils/constant.utils';
import { getRequestUserSessionData as getUserData, convertToTimeZoneDate } from '../../../../../../utils/helpers.utils';
import { getVendorDetails } from '../../../order-request.functions';
import Moment from 'moment';

import {
    wirelineLocationModelA
    , wirelineSubscriptionModelA
    , wirelineBusinessModelA
    , setCountryOptions
    , setAddressOptions
    , setVendorDetails
    , setVendorOptions
    , setCategoryOptions
    , setCircuitTypeOptions
    , setSubCircuitTypeOptions
    , setPrimarySecondaryOptions
    , setDefaultPrimarySecondary
    , setPurposeOfUseOptions
    , setFormSubmitted
    , setNewApproverDetails
    , setFirstLoad
    , setAddress1Options
    , setAddress2Options
    , setCountryLoading
    , setAddressLoading
    , setAddress1Loading
    , setAddress2Loading
} from './../../../../../../constants/model-reducers/external/request/wireline-request/new-circuit/new-circuit-subscription.settings';

export const wirelineLocationModelAInitialState = wirelineLocationModelA;
export const wirelineSubscriptionModelAInitialState = wirelineSubscriptionModelA;
export const wirelineBusinessModelAInitialState = wirelineBusinessModelA;

const defaultState = () => ({
    countryOptions: []
    , addressOptions: []
    , address1Options: []
    , address2Options: []
    , preferredVendorOptions: []
    , nonPrefVendorOptions: []
    , categoryOptions: []
    , circuitTypeOptions: []
    , subCircuitTypeOptions: []
    , primarySecondaryOptions: []
    , defaultPrimarySecondary: []
    , purposeOfUseOptions: []
    , vendorDetails: {
        Currency: ''
    }
    , firstLoad: true
    , formSubmitted: false
    , newApproverDetails: []
    , isSearchNewApprover: false
    , isAmending: false
    , countryPage: 1
    , hasMoreCountry: true
    , isCountryLoading: false
    , deliveryAddressPage: 1
    , hasMoreDeliveryAddress: true
    , isDeliveryAddressLoading: false
    , deliveryAddress1Page: 1
    , hasMoreDeliveryAddress1: true
    , isDeliveryAddress1Loading: false
    , deliveryAddress2Page: 1
    , hasMoreDeliveryAddress2: true
    , isDeliveryAddress2Loading: false
});

const initialState = defaultState();

export const newCircuitSubscriptionActions = {
    getNewCircuitFormData: () => async (dispatch, state) => {

        const { requestTypeId, requestOnBehalfData } = state().createRequest;
        const { requestData, isAmending } = state().requestDetail;
        var robData = {
            "userId": sessionStorage.UserID,
            "employeeID": requestOnBehalfData.EmployeeId,           
            "enterpriseId": requestOnBehalfData.Eid,           
            "requestInBehalfId": null
        }

        var data = {
            RequestTypeId: requestTypeId
            , OrderId: isAmending ? requestData.Order.OrderId : 0
            , User: requestOnBehalfData.EmployeeId ? { ...robData } : { ...getUserData() }
        };

        var res = await httpPost('external/orderRequest/getOrderForm', data);
        await dispatch(newCircuitSubscriptionActions.getAllCountries(1, requestData?.LocationAddress?.CountryName || ''));
        if (requestData?.LocationAddress?.CountryName) {
            await dispatch(newCircuitSubscriptionActions.getDeliveryAddressDropdownAsync(requestData?.LocationAddress?.CountryName || null, 1, requestData?.LocationAddress?.DeliveryAddress || ''));
            await dispatch(newCircuitSubscriptionActions.getDeliveryAddress1DropdownAsync(requestData?.LocationAddress?.CountryName || null, 1, requestData?.LocationAddress?.DeliveryAddress || ''));
            await dispatch(newCircuitSubscriptionActions.getDeliveryAddress2DropdownAsync(requestData?.LocationAddress?.CountryName || null, 1, requestData?.LocationP2P?.DeliveryAddress || ''));
        }
        if (res != null) {
            dispatch({ type: setCategoryOptions, data: res.ItemUses });
            dispatch({ type: setCircuitTypeOptions, data: res.CircuitTypes });
            dispatch({ type: setDefaultPrimarySecondary, data: res.PrimarySecondaryOptions });
            dispatch({ type: setPurposeOfUseOptions, data: res.PurposeOfUse });

            if(isAmending) {

                getCircuitTypes(dispatch, requestData.Subscription.ItemUseId);
                getSubCircuitTypes(dispatch, requestData.Subscription.CircuitTypeId);
                getApproverDetails(requestData.WireLineApprover.LastName + ", " + requestData.WireLineApprover.FirstName, dispatch, state, requestData.WireLineApprover.EmployeeId)

                if(requestData.Subscription.SubCircuitTypeId !== undefined && requestData.Subscription.SubCircuitTypeId !== null)
                {
                    updatePrimarySecondaryOptions(dispatch, state, requestData.Subscription.SubCircuitTypeId, SUBCIRCUITTYPES)
                }
                else{
                    updatePrimarySecondaryOptions(dispatch, state, requestData.Subscription.CircuitTypeId, CIRCUITTYPES);
                }

                dispatch(actions.change('wirelineLocationFormA.isAmending', isAmending));
                dispatch(actions.change('wirelineLocationFormA.country', requestData.LocationAddress.CountryName));
                dispatch(actions.change('wirelineLocationFormA.countryCode', requestData.LocationAddress.CountryCode));

                if(requestData.BillingAddress.LocationId !== undefined && requestData.BillingAddress.LocationId !== null && requestData.BillingAddress.LocationId !== 0){
                    dispatch(actions.change('wirelineLocationFormA.billingAddress', requestData.BillingAddress.LocationName));
                    dispatch(actions.change('wirelineLocationFormA.billingAddressId', requestData.BillingAddress.LocationId));
                }

                dispatch(actions.change('wirelineLocationFormA.locationAddress', requestData.LocationAddress.DeliveryAddress));
                dispatch(actions.change('wirelineLocationFormA.locationAddressId', requestData.LocationAddress.LocationId));
                dispatch(actions.change('wirelineLocationFormA.demarcLocation', requestData.DemarcLocation));

                if(requestData.LocationP2P !== undefined && requestData.LocationP2P !== null){
                    dispatch(actions.change('wirelineLocationFormA.locationAddressP2P', requestData.LocationP2P.DeliveryAddress));
                    dispatch(actions.change('wirelineLocationFormA.locationAddressPTPId', requestData.LocationP2P.LocationId));
                }

                getVendors(dispatch, state);
                dispatch(actions.change('wirelineLocationFormA.demarcLocationPTP', requestData.DemarcLocationPTP));
                dispatch(actions.change('wirelineSubscriptionFormA.vendorDetailId', requestData.Subscription.VendorDetailId));
                dispatch(actions.change('wirelineSubscriptionFormA.itemUseId', requestData.Subscription.ItemUseId));
                dispatch(actions.change('wirelineSubscriptionFormA.circuitTypeId', requestData.Subscription.CircuitTypeId));

                if(requestData.Subscription.SubCircuitTypeId !== undefined && requestData.Subscription.SubCircuitTypeId !== null){
                    dispatch(actions.change('wirelineSubscriptionFormA.subCircuitTypeId',requestData.Subscription.SubCircuitTypeId));
                }

                primarySecondaryUpdateDetails(dispatch, state, requestData.Subscription.PrimarySecondary);
                dispatch(actions.change('wirelineSubscriptionFormA.btn', requestData.Subscription.BtnText));

                if(requestData.Subscription.BtnId !== "" && requestData.Subscription.BtnId !== undefined && requestData.Subscription.BtnId !== null){
                    dispatch(actions.change('wirelineSubscriptionFormA.btnId', requestData.Subscription.BtnId));
                }

                dispatch(actions.change('wirelineSubscriptionFormA.mrc', requestData.Subscription.Mrc));
                dispatch(actions.change('wirelineSubscriptionFormA.nrc', requestData.Subscription.Nrc));
                dispatch(actions.change('wirelineSubscriptionFormA.mrc2', requestData.Subscription.Mrc2));
                dispatch(actions.change('wirelineSubscriptionFormA.nrc2', requestData.Subscription.Nrc2));
                dispatch(actions.change('wirelineSubscriptionFormA.totalCost', parseFloat(requestData.Subscription.Mrc) + parseFloat(requestData.Subscription.Nrc) + parseFloat(requestData.Subscription.Mrc2) + parseFloat(requestData.Subscription.Nrc2)));
                dispatch(actions.change('wirelineBusinessFormA.wireLineApprover', requestData.WireLineApprover.LastName + ", " + requestData.WireLineApprover.FirstName));
                dispatch(actions.change('wirelineBusinessFormA.wireLineApproverId', requestData.WireLineApprover.EmployeeId));
                dispatch(actions.change('wirelineBusinessFormA.wireLineGlCode', requestData.BusinessWireline.CircuitCostAllocations.GLCode));
                dispatch(actions.change('wirelineBusinessFormA.wireLineGlCodeId', requestData.BusinessWireline.CircuitCostAllocations.GLCodeID));
                dispatch(actions.change('wirelineBusinessFormA.wireLineCostCenter', requestData.BusinessWireline.CircuitCostAllocations.CostCode));
                dispatch(actions.change('wirelineBusinessFormA.wireLineCostCenterId', requestData.BusinessWireline.CircuitCostAllocations.CostCodeID));
                dispatch(actions.change('wirelineBusinessFormA.needByDate', new Date(requestData.Order.NeedByDate)));
                dispatch(actions.change('wirelineBusinessFormA.expediteRequest', requestData.BusinessWireline.ExpediteRequest.toString()));
                dispatch(actions.change('wirelineBusinessFormA.purposeOfUseId', requestData.BusinessJustification.PurposeOfUseId));
                dispatch(actions.change('wirelineBusinessFormA.businessJustification', requestData.BusinessJustification.BusinessJustification));
                dispatch(actions.change('wirelineBusinessFormA.additionalInformation', requestData.BusinessJustification.AdditionalInformation));
            }
        }

    }

    , onCountrySelect: (model, value) => async (dispatch, state) => {
        const { countryOptions } = state().newCircuitRequest;
        const { wirelineLocationFormA } = state().form;

        const currentCountryCode = wirelineLocationFormA?.countryCode;

        if (currentCountryCode === value) return;

        const selectedCountry = countryOptions.find(c => c.Key === value);

        if (selectedCountry) {
            dispatch(actions.change('wirelineLocationFormA.country', selectedCountry.Value));
            dispatch(actions.change('wirelineLocationFormA.countryCode', selectedCountry.Key));
        }

        dispatch(actions.change('wirelineLocationFormA.locationAddressId', ''));
        dispatch(actions.change('wirelineLocationFormA.demarcLocation', ''));
        dispatch(actions.change('wirelineLocationFormA.locationAddressPTPId', ''));
        dispatch(actions.change('wirelineLocationFormA.demarcLocationPTP', ''));

        await dispatch(newCircuitSubscriptionActions.getDeliveryAddressDropdownAsync(selectedCountry?.Value, 1, ''));
        await dispatch(newCircuitSubscriptionActions.getDeliveryAddress1DropdownAsync(selectedCountry?.Value, 1, ''));
        await dispatch(newCircuitSubscriptionActions.getDeliveryAddress2DropdownAsync(selectedCountry?.Value, 1, ''));
        getVendors(dispatch, state);
    }
    , onSetFirstLoad: (value) => (dispatch,state) => {
        dispatch({ type: setFirstLoad, data: value });
    }
    , onBillingAddressSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineLocationFormA } = state().form;

        if (value === '') {
            dispatch(actions.change('wirelineLocationFormA.billingAddress', ''));
            dispatch(actions.change('wirelineLocationFormA.billingAddressId', null));
        } else {
            if(objects) {
                var obj = objects.find(o => o[propsName] === value);
                if (obj != null && parseInt(obj.LocationId) !== parseInt(wirelineLocationFormA.billingAddressId)) {
                    dispatch(actions.change('wirelineLocationFormA.billingAddress', value));
                    dispatch(actions.change('wirelineLocationFormA.billingAddressId', obj.LocationId));
    
                }
            }           
        }
    }
    , onCategorySelect: (model, value) => async (dispatch, state) => {

        const { wirelineSubscriptionFormA } = state().form;
        let vendorId = wirelineSubscriptionFormA.vendorDetailId;
        dispatch(actions.reset('wirelineSubscriptionFormA'));
        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelineSubscriptionFormA.vendorDetailId', vendorId));

        getCircuitTypes(dispatch, value);
    }
    , onCircuitTypeSelect: (model, value) => async (dispatch, state) => {
        
        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelineSubscriptionFormA.subCircuitTypeId', 0));
        dispatch(actions.change('wirelineSubscriptionFormA.primarySecondaryId', 0));
        dispatch(actions.reset('wirelineSubscriptionFormA.subCircuitTypeId'))
        dispatch(actions.reset('wirelineSubscriptionFormA.primarySecondaryId'))
        dispatch(actions.reset('wirelineSubscriptionFormA.mrc'))
        dispatch(actions.reset('wirelineSubscriptionFormA.nrc'))
        dispatch(actions.reset('wirelineSubscriptionFormA.mrc2'))
        dispatch(actions.reset('wirelineSubscriptionFormA.nrc2'))
        getSubCircuitTypes(dispatch, value);
        updatePrimarySecondaryOptions(dispatch, state, value, CIRCUITTYPES);

    }
    , onChangeSubCircuitType: (model, value) => async (dispatch, state) => {
        dispatch(actions.change(model, value));
        updatePrimarySecondaryOptions(dispatch, state, value, SUBCIRCUITTYPES);
    }
    , onChangePrimarySecondary: (model, value) => async (dispatch, state) => {
        dispatch(actions.change(model, value));

        dispatch(actions.change('wirelineSubscriptionFormA.btn', ''));
        dispatch(actions.change('wirelineSubscriptionFormA.btnId', 0));
        dispatch(actions.change('wirelineSubscriptionFormA.mrc2', 0));
        dispatch(actions.change('wirelineSubscriptionFormA.nrc2', 0));
        const { wirelineSubscriptionFormA } = state().form;
        dispatch(actions.change('wirelineSubscriptionFormA.totalCost', parseFloat(wirelineSubscriptionFormA.mrc, 10) + parseFloat(wirelineSubscriptionFormA.nrc) + 0 + 0));
    }
    , onBTNSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineSubscriptionFormA } = state().form;

        if (value === '') {
            dispatch(actions.change('wirelineSubscriptionFormA.btn', ''));
            dispatch(actions.change('wirelineSubscriptionFormA.btnId', 0));
        } else {
            if(objects) {
                var obj = objects.find(o => o[propsName] === value);
                if (obj != null && parseInt(obj.CircuitId) !== parseInt(wirelineSubscriptionFormA.btnId)) {
                    dispatch(actions.change('wirelineSubscriptionFormA.btn', value));
                    dispatch(actions.change('wirelineSubscriptionFormA.btnId', obj.CircuitId));
    
                }
            }
        }
    }
    , onApproverSelect: (value, propsName, objects) => (dispatch, state) => {
        const { wirelineBusinessFormA } = state().form;

        if (value === '' || !objects) {
            dispatch(actions.change('wirelineBusinessFormA.wireLineApprover', ''));
            dispatch(actions.change('wirelineBusinessFormA.wireLineApproverId', 0));
            dispatch({ type: setNewApproverDetails, data: [] });
        } else {
            const obj = objects.find(o => o[propsName] === value);
            if (obj != null) {
                if (parseInt(obj.EmployeeId) !== parseInt(wirelineBusinessFormA.wireLineApproverId)) {
                    dispatch(actions.change('wirelineBusinessFormA.wireLineApprover', value));
                    dispatch(actions.change('wirelineBusinessFormA.wireLineApproverId', obj.EmployeeId));
                }
                getApproverDetails(value, dispatch, state, obj.EmployeeId);
            }
        }
    }
    , onGLCodeSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineBusinessFormA } = state().form;

        if (value === '') {
            dispatch(actions.change('wirelineBusinessFormA.wireLineGlCode', ''));
            dispatch(actions.change('wirelineBusinessFormA.wireLineGlCodeId', 0));
        } else {
           if(objects) {
                var obj = objects.find(o => o[propsName] === value);
                if (obj != null && parseInt(obj.GlcodeId) !== parseInt(wirelineBusinessFormA.wireLineGlCodeId)) {
                    dispatch(actions.change('wirelineBusinessFormA.wireLineGlCode', value));
                    dispatch(actions.change('wirelineBusinessFormA.wireLineGlCodeId', obj.GlcodeId));
                }
           }
        }
    }
    , onDateSelect: (value, propsName, objects) => (dispatch, state) => {

        if (value === undefined || value === '') {
            dispatch(actions.change('wirelineBusinessFormA.needByDate', ''));
        } else {
            dispatch(actions.change('wirelineBusinessFormA.needByDate', value));
        }
    }
    , onCostCenterSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineBusinessFormA } = state().form;

        if (value === '') {
            dispatch(actions.change('wirelineBusinessFormA.wireLineCostCenter', ''));
            dispatch(actions.change('wirelineBusinessFormA.wireLineCostCenterId', 0));
        } else {
            if(objects) {
                var obj = objects.find(o => o[propsName] === value);
                if (obj != null && parseInt(obj.CostCodeId) !== parseInt(wirelineBusinessFormA.wireLineCostCenterId)) {
                    dispatch(actions.change('wirelineBusinessFormA.wireLineCostCenter', value));
                    dispatch(actions.change('wirelineBusinessFormA.wireLineCostCenterId', obj.CostCodeId));
                }
            }           
        }
    }
    , onExpediteSelect: (model,value) => async(dispatch,state)=>{
        dispatch(actions.change('wirelineBusinessFormA.expediteRequest',value))
        dispatch(actions.reset('wirelineBusinessFormA.businessJustification'))
    }
    , onVenderSelect : (model,value) => async(dispatch,state) =>{
        dispatch(actions.change('wirelineSubscriptionFormA.vendorDetailId',value))
        dispatch(actions.reset('wirelineSubscriptionFormA.itemUseId'))
        dispatch(actions.reset('wirelineSubscriptionFormA.circuitTypeId'))
        dispatch(actions.reset('wirelineSubscriptionFormA.subCircuitTypeId'))
        dispatch(actions.reset('wirelineSubscriptionFormA.primarySecondaryId'))
        dispatch(actions.reset('wirelineSubscriptionFormA.mrc'))
        dispatch(actions.reset('wirelineSubscriptionFormA.nrc'))
        dispatch(actions.reset('wirelineSubscriptionFormA.mrc2'))
        dispatch(actions.reset('wirelineSubscriptionFormA.nrc2'))
    }
    , onChangeMRC: (model, value) => (dispatch, state) => {

        var newValue = value === "" ? 0 : value;

        dispatch(actions.change(model, newValue));
        const { wirelineSubscriptionFormA } = state().form;

        var nrc = wirelineSubscriptionFormA.nrc === "" ? 0 : wirelineSubscriptionFormA.nrc;
        var mrc2 = wirelineSubscriptionFormA.mrc2 === "" ? 0 : wirelineSubscriptionFormA.mrc2;
        var nrc2 = wirelineSubscriptionFormA.nrc2 === "" ? 0 : wirelineSubscriptionFormA.nrc2;

        dispatch(actions.change('wirelineSubscriptionFormA.totalCost', parseFloat(newValue) + parseFloat(nrc) + parseFloat(mrc2) + parseFloat(nrc2)));
    }
    , onChangeNRC: (model, value = 0) => (dispatch, state) => {

        var newValue = value === "" ? 0 : value;

        dispatch(actions.change(model, newValue));
        const { wirelineSubscriptionFormA } = state().form;

        var mrc = wirelineSubscriptionFormA.mrc === "" ? 0 : wirelineSubscriptionFormA.mrc;
        var mrc2 = wirelineSubscriptionFormA.mrc2 === "" ? 0 : wirelineSubscriptionFormA.mrc2;
        var nrc2 = wirelineSubscriptionFormA.nrc2 === "" ? 0 : wirelineSubscriptionFormA.nrc2;

        dispatch(actions.change('wirelineSubscriptionFormA.totalCost', parseFloat(mrc) + parseFloat(newValue) + parseFloat(mrc2) + parseFloat(nrc2)));
    }
    , onChangeMRC2: (model, value) => (dispatch, state) => {

        var newValue = value === "" ? 0 : value;

        dispatch(actions.change(model, newValue));
        const { wirelineSubscriptionFormA } = state().form;

        var mrc = wirelineSubscriptionFormA.mrc === "" ? 0 : wirelineSubscriptionFormA.mrc;
        var nrc = wirelineSubscriptionFormA.nrc === "" ? 0 : wirelineSubscriptionFormA.nrc;
        var nrc2 = wirelineSubscriptionFormA.nrc2 === "" ? 0 : wirelineSubscriptionFormA.nrc2;

        dispatch(actions.change('wirelineSubscriptionFormA.totalCost', parseFloat(mrc) + parseFloat(nrc) + parseFloat(nrc2) + parseFloat(newValue)));
    }
    , onLocationAddressSelect: (model,value) => (dispatch,state) => {
        const { addressOptions } = state().newCircuitRequest;
        const addressSelected = addressOptions.length > 0 ? addressOptions.find(r => r.Key === value).Value : '';
        dispatch(actions.change(model, addressSelected));
    }
    , onLocationAddress1Select: (model, value) => (dispatch, state) => {
        const { address1Options } = state().newCircuitRequest;
        const addressSelected = address1Options.length > 0 ? address1Options.find(r => r.Key === value).Value : '';
        dispatch(actions.change(model, addressSelected));
    }
    , onLocationAddress2Select: (model, value) => (dispatch, state) => {
        const { address2Options } = state().newCircuitRequest;
        const addressSelected = address2Options.length > 0 ? address2Options.find(r => r.Key === value).Value : '';
        dispatch(actions.change(model, addressSelected));
    }
    , onChangeNRC2: (model, value) => (dispatch, state) => {

        var newValue = value === "" ? 0 : value;

        dispatch(actions.change(model, newValue));
        const { wirelineSubscriptionFormA } = state().form;

        var mrc = wirelineSubscriptionFormA.mrc === "" ? 0 : wirelineSubscriptionFormA.mrc;
        var nrc = wirelineSubscriptionFormA.nrc === "" ? 0 : wirelineSubscriptionFormA.nrc;
        var mrc2 = wirelineSubscriptionFormA.mrc2 === "" ? 0 : wirelineSubscriptionFormA.mrc2;

        dispatch(actions.change('wirelineSubscriptionFormA.totalCost', parseFloat(mrc) + parseFloat(nrc) + parseFloat(mrc2) + parseFloat(newValue)));
    }

    // End Business Actions

    , submitRequest: (date) => async (dispatch, state) => {

        const { requestTypeId, isWirelineRequest, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { wirelineLocationFormA
            , wirelineSubscriptionFormA
            , wirelineBusinessFormA
        } = state().form;
        const { requestData, isAmending } = state().requestDetail;
        const { activeTimeZoneOffset } = state().adminSetting;

        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
            userData.employeeID = requestOnBehalfData.EmployeeId;
        }

        var data = {
            // this block is temporary so that request will not fail (need refactor on the backend)
            LocationOrderModel: { ...wirelineLocationFormA, isWirelineRequest: isWirelineRequest }
            , SubscriptionModel: { ...wirelineSubscriptionFormA }
            , BusinessJustificationModel: { ...wirelineBusinessFormA }
            // end

            , WirelineLocationModel: { ...wirelineLocationFormA }
            , WirelineSubscriptionModel: { ...wirelineSubscriptionFormA }
            , WirelineBusinessModel: {
                ...wirelineBusinessFormA
                , needByDate: wirelineBusinessFormA.needByDate ? Moment(wirelineBusinessFormA.needByDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') : null
            }
            ,  ChangeRequestModel: {
                ...userData
                , ...wirelineSubscriptionFormA
                , CircuitId: wirelineSubscriptionFormA.btnId ? wirelineSubscriptionFormA.btnId : 0                
                , RequestTypeId: requestTypeId
                , OrderId: isAmending ? requestData.CircuitOrderId : 0
                , NoEmail: true
            }
            , User: { ...userData }
            , NoEmail: false
            , RequestTypeId: requestTypeId
            , OrderRequestAutoApproved: false
            , OrderId: isAmending ? requestData.Order.OrderId : 0
            , CircuitId: isAmending ? requestData.CircuitId : 0
            , CircuitOrderId: isAmending ? requestData.CircuitOrderId : 0
            , OrderHistoryId: isAmending ? requestData.OrderHistoryId : 0
            , OrderInfoId: isAmending ? requestData.OrderInfoId : 0
            , IsAmending: isAmending
            , LastModifiedforCostAllocationSection: `${sessionStorage.FirstName} ${sessionStorage.LastName} on 
                          ${Moment(convertToTimeZoneDate(new Date(),activeTimeZoneOffset?.UtcOffset)).format('L')} ${Moment(convertToTimeZoneDate(new Date(),activeTimeZoneOffset?.UtcOffset)).format('LT')}`            
        };

        dispatch({ type: setFormSubmitted, data: true });
        var res = await httpPost('external/orderRequest', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;
    }
    , resetNewCircuitForm: () => (dispatch,state) => {
        resetForm(dispatch,state);
    },

    resetNewApproverDetails: () => (dispatch) =>{
        dispatch({ type: setNewApproverDetails, data: [] });   
    },
    getAllCountries: (page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;

        dispatch({type: setCountryLoading, payload: true});

        let url = `external/order/getCountriesDropdownListAsync/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: setCountryOptions,
                    payload: {
                        countries: res,
                        countryPage: page
                    }
                });
            }
        } catch (err) {
            dispatch({ type: setCountryLoading, payload: false });
        } finally {
            dispatch({ type: setCountryLoading, payload: false });
        }

    },
    getDeliveryAddressDropdownAsync: (countryName, page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;

        dispatch({ type: setAddressLoading, payload: true });

        let url = `external/order/getDeliveryAddressDropdownAsync/${countryName}/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            if (Array.isArray(res)) {
                dispatch({
                    type: setAddressOptions,
                    payload: {
                        deliveryAddresses: res,
                        deliveryAddressPage: page,
                        pageSize
                    }
                });
            }
        } catch (err) {
            dispatch({ type: setAddressLoading, payload: false });
        } finally {
            dispatch({ type: setAddressLoading, payload: false });
        }
    },
    getDeliveryAddress1DropdownAsync: (countryName, page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;

        dispatch({ type: setAddress1Loading, payload: true });

        let url = `external/order/getDeliveryAddressDropdownAsync/${countryName}/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            if (Array.isArray(res)) {
                dispatch({
                    type: setAddress1Options,
                    payload: {
                        deliveryAddresses: res,
                        deliveryAddressPage: page,
                        pageSize
                    }
                });
            }
        } catch (err) {
            dispatch({ type: setAddress1Loading, payload: false });
        } finally {
            dispatch({ type: setAddress1Loading, payload: false });
        }
    },
    getDeliveryAddress2DropdownAsync: (countryName, page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;

        dispatch({ type: setAddress2Loading, payload: true });

        let url = `external/order/getDeliveryAddressDropdownAsync/${countryName}/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            if (Array.isArray(res)) {
                dispatch({
                    type: setAddress2Options,
                    payload: {
                        deliveryAddresses: res,
                        deliveryAddressPage: page,
                        pageSize
                    }
                });
            }
        } catch (err) {
            dispatch({ type: setAddress2Loading, payload: false });
        } finally {
            dispatch({ type: setAddress2Loading, payload: false });
        }
    },
}

function resetForm(dispatch,state) {
    dispatch(actions.reset('wirelineLocationFormA'));
    dispatch(actions.reset('wirelineSubscriptionFormA'));
    dispatch(actions.reset('wirelineBusinessFormA'));
    dispatch({ type: setFormSubmitted, data: false });

}

function updatePrimarySecondaryOptions(dispatch, state, value, types) {

    const { defaultPrimarySecondary } = state().newCircuitRequest;

    if ((Object.values(types).indexOf(parseInt(value)) > -1)) {
        dispatch({ type: setPrimarySecondaryOptions, data: defaultPrimarySecondary });
    } else {
        dispatch({ type: setPrimarySecondaryOptions, data: defaultPrimarySecondary.slice(0, 2) });
    }
}

function primarySecondaryUpdateDetails(dispatch, state, value){

    const { defaultPrimarySecondary } = state().newCircuitRequest;
    const selectedPrimarySecondary =  defaultPrimarySecondary.length > 0 ? defaultPrimarySecondary.find(x => x.Value === value).Key : "";
    dispatch(actions.change('wirelineSubscriptionFormA.primarySecondaryId',selectedPrimarySecondary));
}

async function getVendors(dispatch, state) {

    const { isWirelineRequest } = state().createRequest;
    const { wirelineLocationFormA } = state().form;

    var data = {
        ...wirelineLocationFormA
        , IsWirelineRequest: isWirelineRequest
    };

    var res = await httpPost('external/orderRequest/getVendors', data);
    if (res.ok === undefined && res.Vendors.length > 0) {
        dispatch({
            type: setVendorOptions
            , prefVendors: res.Vendors
        });
        if (parseInt(res.Vendors[0].Key) !== 0) {
            dispatch(actions.change('wirelessSubscriptionFormA.vendorDetailId', res.Vendors[0].Key));
            getVendorDetails(dispatch, setVendorDetails, defaultState.vendorDetails, res.Vendors[0].Key);
        }
    }
}

async function getSubCircuitTypes(dispatch, value) {

    var res = await httpGet('external/orderRequest/getSubCircuitTypes/' + value);

    if (res != null) {
        dispatch({ type: setSubCircuitTypeOptions, data: res });
    } else {
        dispatch({ type: setSubCircuitTypeOptions, data: res });
    }


      dispatch({ type: setSubCircuitTypeOptions, data: res });

    return res != null;
}



async function getCircuitTypes(dispatch, value) {
    var res = await httpGet('external/orderRequest/getCircuitTypes/' + value);
    if (res != null) {
        dispatch({ type: setCircuitTypeOptions, data: res });
    } else {
        dispatch({ type: setCircuitTypeOptions, data: res });
    }
    return res != null;
}

async function getApproverDetails(val, dispatch,state, employeeId = null) {
    const {  isRequestOnBehalf } = state().createRequest;
    const canSearch = isRequestOnBehalf;
    const approvalDetails = await httpGet(newApprovalDetails(val, canSearch, isRequestOnBehalf, state));
    let selectedApproverDetails = Array.isArray(approvalDetails) ? approvalDetails : [];
    if (employeeId != null) {
        selectedApproverDetails = selectedApproverDetails.filter(item =>
            parseInt(item.EmployeeID ?? item.EmployeeId) === parseInt(employeeId)
        );
    }
    dispatch({
        type: setNewApproverDetails,
        data: selectedApproverDetails,
        isSearchNewApprover: selectedApproverDetails.length > 0
    });
}

function newApprovalDetails(val, canSearchSelf, isRequestOnBehalf, state) {

    const { requestTypeId, requestOnBehalfData } = state()?.createRequest;

    var empIdRob = requestOnBehalfData.EmployeeId

    return 'external/autosuggest/getEmployees/'
        + sessionStorage.EmployeeID + '/'
        + sessionStorage.UserRoleID + '/'
        + sessionStorage.IsExecutive + '/'
        + sessionStorage.IsKeyUser + '/'
        + val + '/'
        + isRequestOnBehalf + '/'
        + requestTypeId + '/'
        + empIdRob + '/'
        + canSearchSelf
}

export const onSelectedApprover = (value, employeeId = null) => (dispatch, state) => {
 
    if (value === '') {        
        dispatch({ type: setNewApproverDetails, data: [] });
    } else {
        getApproverDetails(value, dispatch, state, employeeId);
    }
};

export const resetWirelineApprover = () => (dispatch, state) => {
    dispatch({ type: setNewApproverDetails, data: [] });
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setCountryOptions:
            const { countries, countryPage } = action.payload;
            return {
                ...state,
                countryOptions: countryPage === 1 ? countries : [...state.countryOptions, ...countries],
                hasMoreCountry: countries.length > 0,
                countryPage: countryPage
            }
        case setCountryLoading:
            return {
                ...state,
                isCountryLoading: action.payload
            };
        case setAddressOptions: {
            const {
                deliveryAddresses = [],
                deliveryAddressPage,
                pageSize = 15,
                totalCount = null
            } = action.payload;

            let mergedList =
                deliveryAddressPage === 1
                    ? deliveryAddresses
                    : [...state.addressOptions, ...deliveryAddresses];
            const seen = new Set();
            const uniqueList = [];
            for (const item of mergedList) {
                if (!seen.has(item.Key)) {
                    seen.add(item.Key);
                    uniqueList.push(item);
                }
            }
            const isLastPage = totalCount !== null
                ? uniqueList.length >= totalCount
                : deliveryAddresses.length < pageSize;

            if (isLastPage) {
                const filtered = uniqueList.filter(i => i.Key !== -1);
                filtered.push({ Key: -1, Value: "Other" });
                return {
                    ...state,
                    addressOptions: filtered,
                    hasMoreDeliveryAddress: false,
                    deliveryAddressPage
                };
            }
            return {
                ...state,
                addressOptions: uniqueList,
                hasMoreDeliveryAddress: deliveryAddresses.length === pageSize,
                deliveryAddressPage
            };
        };
        case setAddress1Options: {
            const {
                deliveryAddresses = [],
                deliveryAddressPage,
                pageSize = 15,
                totalCount = null
            } = action.payload;

            let mergedList =
                deliveryAddressPage === 1
                    ? deliveryAddresses
                    : [...state.address1Options, ...deliveryAddresses];
            const seen = new Set();
            const uniqueList = [];
            for (const item of mergedList) {
                if (!seen.has(item.Key)) {
                    seen.add(item.Key);
                    uniqueList.push(item);
                }
            }
            const isLastPage = totalCount !== null
                ? uniqueList.length >= totalCount
                : deliveryAddresses.length < pageSize;

            if (isLastPage) {
                const filtered = uniqueList.filter(i => i.Key !== -1);
                filtered.push({ Key: -1, Value: "Other" });
                return {
                    ...state,
                    address1Options: filtered,
                    hasMoreDeliveryAddress1: false,
                    deliveryAddress1Page: deliveryAddressPage
                };
            }
            return {
                ...state,
                address1Options: uniqueList,
                hasMoreDeliveryAddress1: deliveryAddresses.length === pageSize,
                deliveryAddress1Page: deliveryAddressPage
            };
        };
        case setAddress2Options: {
            const {
                deliveryAddresses = [],
                deliveryAddressPage,
                pageSize = 15,
                totalCount = null
            } = action.payload;

            let mergedList =
                deliveryAddressPage === 1
                    ? deliveryAddresses
                    : [...state.address2Options, ...deliveryAddresses];
            const seen = new Set();
            const uniqueList = [];
            for (const item of mergedList) {
                if (!seen.has(item.Key)) {
                    seen.add(item.Key);
                    uniqueList.push(item);
                }
            }
            const isLastPage = totalCount !== null
                ? uniqueList.length >= totalCount
                : deliveryAddresses.length < pageSize;

            if (isLastPage) {
                const filtered = uniqueList.filter(i => i.Key !== -1);
                filtered.push({ Key: -1, Value: "Other" });
                return {
                    ...state,
                    address2Options: filtered,
                    hasMoreDeliveryAddress2: false,
                    deliveryAddress2Page: deliveryAddressPage
                };
            }
            return {
                ...state,
                address2Options: uniqueList,
                hasMoreDeliveryAddress2: deliveryAddresses.length === pageSize,
                deliveryAddress2Page: deliveryAddressPage
            };
        };
        case setAddressLoading:
            return {
                ...state,
                isDeliveryAddressLoading: action.payload
            };
        case setAddress1Loading:
            return {
                ...state,
                isDeliveryAddress1Loading: action.payload
            };
        case setAddress2Loading:
            return {
                ...state,
                isDeliveryAddress2Loading: action.payload
            };
        case setVendorOptions:
            return {
                ...state,
                preferredVendorOptions: action.prefVendors
                , nonPrefVendorOptions: action.nonPrefVendors
            };
        case setCategoryOptions:
            return {
                ...state,
                categoryOptions: action.data
            };
        case setCircuitTypeOptions:
            return {
                ...state,
                circuitTypeOptions: action.data
            };
        case setSubCircuitTypeOptions:
            return {
                ...state,
                subCircuitTypeOptions: action.data
            };
        case setPrimarySecondaryOptions:
            return {
                ...state,
                primarySecondaryOptions: action.data
            };
        case setDefaultPrimarySecondary:
            return {
                ...state,
                defaultPrimarySecondary: action.data
            };
        case setPurposeOfUseOptions:
            return {
                ...state,
                purposeOfUseOptions: action.data
            };
        case setVendorDetails:
            return {
                ...state,
                vendorDetails: action.data
            };
        case setFormSubmitted:
            return {
                ...state,
                formSubmitted: action.data
            };
        case setNewApproverDetails: 
            return {
                ...state,
                newApproverDetails: action.data,
                isSearchNewApprover: action.isSearchNewApprover
            }
        case setFirstLoad:
            return {
                ...state,
                firstLoad: action.data
            }
        default: return state;
    }
}